/**
 * @author Arul Vivek
 */
import constants, { HTTP_METHODS } from "../../../settings/shared/constants"
import axiosClientDB from "../../general"

function _constructHeader(projectId) {
    let headers = {
        'Content-Type': 'application/json',
        "project-id": projectId
    }
    return headers;
}

function getDatabaseInfo(projectId) {
    return axiosClientDB({
        url: constants.api.database.getDatabaseInfo,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(projectId)
    })
    // return Promise.resolve(STATIC_DATABASE_INFO.map((database) => ({ ...database })))
}

function getDatabaseTables(projectId) {
    return axiosClientDB({
        url: constants.api.database.getDatabaseTables,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(projectId)
    })
}

function getTableData(tableName, projectId) {
    return axiosClientDB({
        url: constants.api.database.getTableData + "?table_name=" + tableName,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(projectId)
    })
    }

function getTableSchema(tableName, schemaName, projectId) {
    return axiosClientDB({
        url: constants.api.database.getTableSchema + "?table_name=" + tableName + "&schema=" + schemaName,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(projectId)
    })
}

//To export database functions
const DatabaseService = {
    getDatabaseInfo,
    getDatabaseTables,
    getTableData,
    getTableSchema
}

export default DatabaseService;

